export const PhonePrefixes = ['+33', '+212', '+34', '+39', '+31', '+32', '+1'];

export const PhoneToCountryCodeMapper = {
  '+33': 'fr',
  '+212': 'ma',
  '+34': 'es',
  '+39': 'it',
  '+31': 'nl',
  '+32': 'be',
  '+1': 'us',
};

export const AllowedPhoneCountriesList = ['fr', 'ma', 'es', 'it', 'nl', 'be', 'us'];
export const AllowedPhoneCountries = ['fr', 'ma', 'es', 'it', 'nl', 'be', 'us'] as const;
